module.exports = __webpack_public_path__ + "img/BlinkArt_Sword5_Yellow.68554675.png";